import ShopItem from '@/model/ShopItem';

export const prepareStore = {
  state: {
    selectedItem: new ShopItem(),
    selectedQty: 1,
    selectedPostcard: {
      id: null,
      name: '',
      image: '',
      handwriting: 'op1',
      from: '',
      to: '',
      message: '',
      contact: 'op2'
    },
    futureDate: {
      use: false,
      val: ''
    }
  },
  getters: {
    getSelectedItem: state => {
      return state.selectedItem;
    },
    getSelectedQty: state => {
      return state.selectedQty;
    },
    getSelectedPostcard: state => {
      return state.selectedPostcard;
    },
    getSelectedPostcardMessage: state => {
      return state.selectedPostcard.message;
    },
    getLevel3Box: state => {
      if (
        state.selectedItem.data !== null &&
        state.selectedItem.data.type === 'level_3'
      ) {
        return state.selectedItem.data.box;
      }
      return {
        price: {},
        originalPrice: 0,
        originalPriceNet: 0
      };
    },
    getFutureDate: state => {
      return state.futureDate;
    }
  },
  mutations: {
    setSelectedItem(state, selectedItem) {
      var item = new ShopItem();
      item.data = selectedItem;
      state.selectedItem = item;
      if (selectedItem !== null && selectedItem !== undefined && selectedItem.type === 'level_1') {
        localStorage.setItem('lastSelectedItem', JSON.stringify(selectedItem));
        localStorage.setItem('lastSelectedType', 'level_1');
      } else if (selectedItem !== null && selectedItem !== undefined && selectedItem.type === 'level_3') {
        localStorage.setItem('lastSelectedType', 'level_3');
      }
    },
    removeSelectedLevel1(_) {
      localStorage.removeItem('lastSelectedItem');
    },
    removeSelectedLevel2(_) {
      localStorage.removeItem('lastSelectedItemLevel2');
    },
    removeSelectedLevel3(_) {
      localStorage.removeItem('lastSelectedItemLevel3');
    },
    addLevel3(state, product) {
      if (state.selectedItem.data === null) {
        state.selectedItem.data = {
          type: 'level_3',
          products: [],
          qtyCache: {},
          box: {}
        };
      }
      if (product.id in state.selectedItem.data.qtyCache) {
        state.selectedItem.data.qtyCache[product.id] += 1;
      } else {
        state.selectedItem.data.qtyCache[product.id] = 1;
      }
      state.selectedItem.data.products.unshift(product);
      localStorage.setItem(
        'lastSelectedItemLevel3',
        JSON.stringify(state.selectedItem)
      );
      localStorage.setItem('lastSelectedType', 'level_3');
    },
    setLevel3Box(state, box) {
      if (
        state.selectedItem.data === null ||
        state.selectedItem.data === undefined
      ) {
        state.selectedItem.data = {
          type: 'level_3',
          products: [],
          qtyCache: {},
          box: {}
        };
      }
      state.selectedItem.data.box = box;
    },
    removeLevel3(state, index) {
      state.selectedItem.data.qtyCache[
        state.selectedItem.data.products[index].id
      ] -= 1;
      state.selectedItem.data.products.splice(index, 1);
      localStorage.setItem(
        'lastSelectedItemLevel3',
        JSON.stringify(state.selectedItem)
      );
    },
    removeLevel2(state, index) {
      state.selectedItem.data.products.splice(index, 1);
      localStorage.setItem(
        'lastSelectedItemLevel2',
        JSON.stringify(state.selectedItem)
      );
    },
    setSelectedQty(state, payload) {
      payload.qty = parseInt(payload.qty);
      if (payload.qty === 1) {
        state.selectedPostcard.contact = 'op2';
      }
      state.selectedQty = payload.qty;

      if (Number.isInteger(payload.qty)) {
        localStorage.setItem('lastSelectedQty', payload.qty);
      }
    },
    setSelectedPostcardId(state, id) {
      state.selectedPostcard.id = id;
      localStorage.setItem(
        'lastSelectedPostcard',
        JSON.stringify(state.selectedPostcard)
      );
    },
    setSelectedPostcardName(state, name) {
      state.selectedPostcard.name = name;
      localStorage.setItem(
        'lastSelectedPostcard',
        JSON.stringify(state.selectedPostcard)
      );
    },
    setSelectedPostcardImage(state, img) {
      state.selectedPostcard.image = img;
      localStorage.setItem(
        'lastSelectedPostcard',
        JSON.stringify(state.selectedPostcard)
      );
    },
    setSelectedPostcardHandwriting(state, handwriting) {
      state.selectedPostcard.handwriting = handwriting;
      localStorage.setItem(
        'lastSelectedPostcard',
        JSON.stringify(state.selectedPostcard)
      );
    },
    setSelectedPostcardContact(state, contact) {
      state.selectedPostcard.contact = contact;
      localStorage.setItem(
        'lastSelectedPostcard',
        JSON.stringify(state.selectedPostcard)
      );
    },
    setSelectedPostcardTo(state, to) {
      state.selectedPostcard.to = to;
      localStorage.setItem(
        'lastSelectedPostcard',
        JSON.stringify(state.selectedPostcard)
      );
    },
    setSelectedPostcardFrom(state, from) {
      state.selectedPostcard.from = from;
      localStorage.setItem(
        'lastSelectedPostcard',
        JSON.stringify(state.selectedPostcard)
      );
    },
    setSelectedPostcardMessage(state, message) {
      state.selectedPostcard.message = message;
      localStorage.setItem(
        'lastSelectedPostcard',
        JSON.stringify(state.selectedPostcard)
      );
    },
    setFutureDate(state, value) {
      state.futureDate = value;
    }
  }
};
